import { Modal } from 'antd'
import { ClientAddressName } from './ClientKnownAddressModalLink'
import { RemoveButton } from 'portal/components/RecordsModules/common'

export type ClientRemoveKnownAddressWarningModalProps = {
  addressName: ClientAddressName
  isOpen: boolean
  onCancel: () => void
  onSubmit: () => void
}

export function ClientRemoveKnownAddressWarningModal({
  addressName,
  isOpen,
  onCancel,
  onSubmit
}: ClientRemoveKnownAddressWarningModalProps) {
  return (
    <Modal
      title={`Remove ${addressName} Address`}
      open={isOpen}
      onCancel={onCancel}
      footer={[
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
        >
          <RemoveButton onClick={onSubmit} />
        </div>
      ]}
    >
      <strong>
        Are you sure you want to remove the {addressName} address?
      </strong>{' '}
      <br />
      <p>Removing the address will remove mileage and carbon calculations</p>
    </Modal>
  )
}

export default ClientRemoveKnownAddressWarningModal
